/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Tenant from './tenant';
import TenantDetail from './tenant-detail';
import TenantUpdate from './tenant-update';
import TenantDeleteDialog from './tenant-delete-dialog';

const TenantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Tenant />} />
    <Route path="new" element={<TenantUpdate />} />
    <Route path=":id">
      <Route index element={<TenantDetail />} />
      <Route path="edit" element={<TenantUpdate />} />
      <Route path="delete" element={<TenantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantRoutes;
